import { useContext } from "react";
import Valve from "../components/Valve";
import Transmitter from "../components/Transmitter";
import "./H2OInjectionWellhead.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { useState, useEffect } from "react";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";

import { trackPageVisit } from "../competency/PageTracker";

 


/* ✅ Reusable Indicator */
function Indicator({ x, y, isClosed }) {
  return (
    <svg width="80" height="80" style={{ position: "absolute", left: x, top: y }}>
      <circle
        cx="40"
        cy="30"
        r="17"
        fill={isClosed ? "red" : "lime"}
        stroke="black"
        strokeWidth="2"
      />
    </svg>
  );
}


 
      /* ✅ CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }



function H2OInjectionWellhead() {

        useEffect(() => {
  
    trackPageVisit("H2OInjectionWellhead");
  
  }, []);

  const {  wellSignals, valves, toggleValve, setTransmitters  } = useContext(WellContext);

      
   const DEFAULT_VALVES = {
            FCV_10401: { mode: "Manual", opening: 0, sp: "", pv: "" },
            CHK_401: { mode: "Manual", opening: 0, sp: "", pv: "" },
            };

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("H2OInjectionWellhead_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_10401: { ...DEFAULT_VALVES.FCV_10401, ...parsed.FCV_10401 },
      CHK_401: { ...DEFAULT_VALVES.CHK_401, ...parsed.CHK_401 },
    };

  } catch {
    return DEFAULT_VALVES;
  }
});


/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("H2OInjectionWellhead_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};




  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };



  // ================= RETREIVING STORED TRANSMITTERS FROM LOCAL STORAGE IN OTHER PAGES =================

  const [FIC_2954, setFIC_2954] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_2954")) || 0;
            setFIC_2954(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [PT_2959, setPT_2959] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("PT_2959")) || 0;
            setPT_2959(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [TT_2953, setTT_2953] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("TT_2953")) || 0;
            setTT_2953(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);







              /* 🔥 TRANSMITTER OUTPUTS */


const isXV10401Open = valves.XV_10401 === false;
const isBBV10401Open = valves.BBV_10401 === false;
const isBDV10401Open = valves.BDV_10401 === false;
const isDHSV10401Open = valves.DHSV_10401 === false;
const isCHK401Open = valves.CHK_401 === false;


const FIC_10401 = FIC_2954;
const PT_10401 = PT_2959;
const TT_10401 = TT_2953;

const FIC_10402 = isXV10401Open ? 30.333 * (valveData.FCV_10401.opening)/100 : 0;
const PT_10402 = isXV10401Open ? 1.3 * (valveData.FCV_10401.opening)/100 : 0;

const FIC_10403 = isXV10401Open ? FIC_10401 - FIC_10402 : 0;
const PT_10403 = isXV10401Open ? PT_10401 * 0.98 : 0.03;

const PT_10404 = isBDV10401Open ? PT_10403 * (valveData.CHK_401.opening)/100 : 0.03;
const FIC_10404 = isBDV10401Open ? FIC_10403 * (valveData.CHK_401.opening)/100 : 0;

const FIC_10405 = isBBV10401Open ? FIC_10404 * 0.965 : 0;
const PT_10405 = isBBV10401Open ? PT_10404 * 0.965 : 0.03;

const FIC_10406 = isDHSV10401Open ? FIC_10405 * 0.978 : 0;
const PT_10406 = isDHSV10401Open ? PT_10405 * 0.978 : 0.03;

const PT_10407 = PT_10405 * 0.675;



  return (
    <div className="H2OInjectionWellhead-container">
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "-20px",
        left: "203px",
        color: "white",
        background: "rgb(29, 4, 253)",
        padding: "2.2px 220px"
      }}>
        WATER INJECTION WELLHEAD - 1
      </h2>


    {/* =================SHUTDOWN VALVES ================= */}

      {/* XV-10401 */}
      <Valve
        className="XV-10401"
        tag="XV_10401"
        x={906}
        y={278}
        isClosed={valves.XV_10401}
        toggle={toggleValve}
      />

      <Indicator
        x={1145}
        y={85}
        isClosed={valves.XV_10401}
      />

      {/* BDV-10401 */}
      <Valve
        className="BDV-10401"
        tag="BDV_10401"
        x={478}
        y={165}
        isClosed={valves.BDV_10401}
        toggle={toggleValve}
      />

      <Indicator
        x={1145}
        y={45}
        isClosed={valves.BDV_10401}
      />

        {/* BBV-10401 */}
      <Valve
        className="BBV-10401"
        tag="BBV_10401"
        x={410}
        y={221}
        isClosed={valves.BBV_10401}
        toggle={toggleValve}
        r={90}
      />

      <Indicator
        x={990}
        y={85}
        isClosed={valves.BBV_10401}
      />

        {/* DHSV-10401 */}
      <Valve
        className="DHSV-10401"
        tag="DHSV_10401"
        x={410}
        y={421}
        isClosed={valves.DHSV_10401}
        toggle={toggleValve}
        r={90}
      />

      <Indicator
        x={990}
        y={45}
        isClosed={valves.DHSV_10401}
      />

       


   


      

      {/* ================= CONTROL VALVES SVG ================= */}

        {/* FCV-10801 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-10801"
          style={{ position: "absolute", left: 900, top: 329 }}  onClick={() => openPanel("FCV_10401")}>
          
          <defs>
            <linearGradient id="metal_10801">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_10801)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_10801)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>

        <svg
            className="CHK-401"
            width="80"
            height="55"
            viewBox="0 0 220 260"
            style={{ position: "absolute", left: 539, top: 165 }}
            onClick={() => openPanel("CHK_401")}
          >

          {/* Top Thin White Accents */}
          <line x1="50" y1="60" x2="200" y2="100" stroke="blue" strokeWidth="12" />
          <line x1="320" y1="60" x2="200" y2="100" stroke="blue" strokeWidth="12" />
          <rect x="50" y="20" width="5" height="30" fill="blue" strokeWidth="12"/>
          
          
          {/* Red Geometric Body Parts */}
          <g fill="#cc0000" stroke="#777" strokeWidth="1">
            {/* Top cap */}
            <rect x="150" y="115" width="100" height="45" />
            
            {/* Upper section */}
            <rect x="110" y="160" width="180" height="55" />
            
            {/* Middle section with notch details */}
            <rect x="110" y="225" width="180" height="100" />
            <rect x="140" y="215" width="20" height="15" />
            <rect x="190" y="215" width="20" height="15" />
            <rect x="240" y="215" width="20" height="15" />
            
            {/* Tapered transition */}
            <polygon points="110,325 290,325 260,370 140,370" />
            
            {/* Lower neck */}
            <rect x="140" y="370" width="120" height="40" />
            
            {/* Base steps */}
            <rect x="130" y="420" width="140" height="25" />
            <rect x="130" y="450" width="140" height="20" />

          </g>
        </svg>


      

        
      {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}





      {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={valveData.FCV_10401.opening}
        x={925}
        y={367}
      />

      <ValveOutput
        value={valveData.CHK_401.opening}
        x={590}
        y={154}
      />



      <Transmitter
          tag="FIC-10401"
          value={[FIC_10401]}
          x={1060}
          y={330}
          unit="LPM"
          max={250}
          HH={240}
          H={220}
          L={50}
          LL={20}
          c="lime"
          description="FLOWRATE OF DE-OXYGENATED SEAWATER FROM DISCHARGE OF MAIN WATER INJECTION PUMPS IN VACUUM DEARATOR UNIT"
        />

        
        <Transmitter
          tag="PT-10401"
          value={PT_10401}
          x={983}
          y={330}
          unit="MPa"
          max={40}
          HH={35}
          H={25}
          L={0.1}
          LL={0.04}
          c="lime"
          description="PRESSURE OF DE-OXYGENATED SEAWATER FROM DISCHARGE OF MAIN WATER INJECTION PUMPS IN VACUUM DEARATOR UNIT"
        />

        <Transmitter
          tag="TT-10401"
          value={TT_10401}
          x={1160}
          y={330}
          unit="°C"
          max={50}
          HH={45}
          H={40}
          L={20}
          LL={5}
          c="lime"
          description="TEMPERATURE OF DE-OXYGENATED SEAWATER FROM DISCHARGE OF MAIN WATER INJECTION PUMPS IN VACUUM DEARATOR UNIT"
        />

        <Transmitter
          tag="FIC-10402"
          value={[FIC_10402]}
          x={830}
          y={330}
          unit="LPM"
          max={250}
          HH={240}
          H={220}
          L={50}
          LL={20}
          c="lime"
          description="FLOWRATE OF INJECTION WATER FROM WATER INJECTION MANIFOLD TO OVERBOARD"
        />

        
        <Transmitter
          tag="PT-10402"
          value={PT_10402}
          x={713}
          y={330}
          unit="MPa"
          max={40}
          HH={35}
          H={25}
          L={0.1}
          LL={0.04}
          c="lime"
          description="PRESSURE OF INJECTION WATER FROM WATER INJECTION MANIFOLD TO OVERBOARD"
        />
      
        <Transmitter
          tag="FIC-10403"
          value={[FIC_10403]}
          x={680}
          y={261}
          unit="LPM"
          max={250}
          HH={240}
          H={220}
          L={50}
          LL={20}
          c="lime"
          description="FLOWRATE OF INJECTION WATER FROM WATER INJECTION MANIFOLD TO CHOKE VALVE"
        />

        
        <Transmitter
          tag="PT-10403"
          value={PT_10403}
          x={680}
          y={212}
          unit="MPa"
          max={40}
          HH={35}
          H={25}
          L={0.1}
          LL={0.04}
          c="lime"
          description="PRESSURE OF INJECTION WATER FROM WATER INJECTION MANIFOLD TO CHOKE VALVE"
        />
      
        <Transmitter
          tag="FIC-10404"
          value={[FIC_10404]}
          x={215}
          y={212}
          unit="LPM"
          max={250}
          HH={240}
          H={220}
          L={50}
          LL={20}
          c="lime"
          description="FLOWRATE OF INJECTION WATER ON INJECTION WELLHEAD AFTER THE CHOKE AND BLOWDOWN VALVE"
        />

        
        <Transmitter
          tag="PT-10404"
          value={PT_10404}
          x={395}
          y={124}
          unit="MPa"
          max={40}
          HH={35}
          H={25}
          L={0.1}
          LL={0.04}
          c="lime"
          description="PRESSURE OF INJECTION WATER ON INJECTION WELLHEAD AFTER THE CHOKE AND BLOWDOWN VALVE"
        />
      
        <Transmitter
          tag="FIC-10405"
          value={[FIC_10405]}
          x={485}
          y={392}
          unit="LPM"
          max={250}
          HH={240}
          H={220}
          L={50}
          LL={20}
          c="lime"
          description="FLOWRATE OF INJECTION WATER BELOW THE INJECTION WELLHEAD AT THE WATER INJECTION CASING"
        />

        
        <Transmitter
          tag="PT-10405"
          value={PT_10405}
          x={300}
          y={392}
          unit="MPa"
          max={40}
          HH={35}
          H={25}
          L={0.1}
          LL={0.04}
          c="lime"
          description="PRESSURE OF INJECTION WATER BELOW THE INJECTION WELLHEAD AT THE WATER INJECTION CASING"
        />
      
        <Transmitter
          tag="FIC-10406"
          value={[FIC_10406]}
          x={575}
          y={478}
          unit="LPM"
          max={250}
          HH={240}
          H={220}
          L={50}
          LL={20}
          c="lime"
          description="FLOWRATE OF INJECTION WATER BELOW THE DOWNHOLE SAFETY VALVE"
        />

        
        <Transmitter
          tag="PT-10406"
          value={PT_10406}
          x={485}
          y={478}
          unit="MPa"
          max={40}
          HH={35}
          H={25}
          L={0.1}
          LL={0.04}
          c="lime"
          description="PRESSURE OF INJECTION WATER BELOW THE DOWNHOLE SAFETY VALVE"
        />
      
        <Transmitter
          tag="PT-10407"
          value={PT_10407}
          x={300}
          y={478}
          unit="MPa"
          max={40}
          HH={35}
          H={25}
          L={0.1}
          LL={0.04}
          c="lime"
          description="PRESSURE OF INJECTION WATER BELOW THE DOWNHOLE SAFETY VALVE"
        />
      
            

    </div>
  );
}

export default H2OInjectionWellhead;